import CustomerLicence from "./Items/CustomerLicence";
import { useEffect, useState } from "react";
import { customerLicences } from "../../endpoints";
import CustomerLicenceLoading from "./Items/CustomerLicenceLoading";
import useFetch from "../../hooks/useFetch";

interface Props {
  name: string;
}

interface licencesData {
  name: string;
  vendor: string;
  term: string;
  end_date: string;
  amount: string;
}

const CustomerLicenses = ({ name }: Props) => {
  const { data, loading } = useFetch<licencesData>(customerLicences, {
    companyName: name,
  });
  const [showNoIncidents, setShowNoIncidents] = useState(false);

  useEffect(() => {
    if (!loading && data.length === 0) {
      const timer = setTimeout(() => {
        setShowNoIncidents(true);
      }, 150);

      return () => clearTimeout(timer);
    } else {
      setShowNoIncidents(false);
    }
  }, [loading, data]);

  return (
    <div className="w-full text-black">
      {/* Head */}
      <div className="p-8 bg-white  rounded-xl mt-6 w-full overflow-auto">
        <b className="text-gray-600 text-2xl">Licensies</b>
        <div className="w-full text-gray-600 flex text-sm p-2 border-b-2">
          <div className="w-3/12 text-left">
            <b>Naam</b>
          </div>
          <div className="w-2/12 text-center">
            <b>Bedrijf</b>
          </div>
          <div className="w-2/12 text-center">
            <b>Termijn</b>
          </div>
          <div className="w-2/12 text-center">
            <b>Verlenging</b>
          </div>
          <div className="w-2/12 text-center">
            <b>Eind</b>
          </div>
          <div className="w-1/12 text-center">
            <b>Aantal</b>
          </div>
        </div>
        {/* Items */}
        <div>
          {loading
            ? Array.from({ length: 8 }).map((_, index) => (
                <CustomerLicenceLoading key={index} />
              ))
            : data.length > 0
            ? data.map((item, index) => (
                <CustomerLicence
                  key={index}
                  name={item.name}
                  company={item.vendor}
                  term={item.term}
                  extenddate="N/N"
                  enddate={item.end_date}
                  total={item.amount}
                />
              ))
            : showNoIncidents && (
                <div className="flex justify-center items-center">
                  <b className="text-2xl m-4 text-gray-600">Klant heeft geen licenties</b>
                </div>
              )}
        </div>
      </div>
    </div>
  );
};

export default CustomerLicenses;
